import { isBefore } from 'date-fns';

export const sortArrayByDate = <T, K extends keyof T>(array: T[], dateKey: K): T[] => {
  return array.sort((a, b) => {
    return isBefore(a[dateKey] as string, b[dateKey] as string) ? -1 : 1;
  });
};

